import { render, staticRenderFns } from "./Takeaway.vue?vue&type=template&id=27112c76&lang=html&"
import script from "./Takeaway.vue?vue&type=script&lang=js&"
export * from "./Takeaway.vue?vue&type=script&lang=js&"
import style0 from "./Takeaway.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports